import * as Sentry from '@sentry/browser';
import { BrowserOptions } from '@sentry/browser';
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';
import { Integration } from '@sentry/types';

export const isEnabled = window.env.SENTRY_USE === 'true';

const replaceSensitiveDataFromPath = (path?: unknown) =>
  typeof path === 'string'
    ? path
        .replace(/(.*)([?|&]userToken=)([^&]*)(&*)/g, '$1$2<sensitive>$4')
        .replace(/(.*)([?|&]token=)([^&]*)(&*)/g, '$1$2<sensitive>$4')
    : path;

let baseConfig: BrowserOptions | undefined;

export const init = (): void => {
  if (!isEnabled || !!baseConfig) {
    return;
  }

  const dsn = window.env.SENTRY_DSN;
  if (!dsn) {
    console.warn('Sentry initialization failed: DSN is not set.');
    return;
  }

  const release = window.env.SENTRY_RELEASE;
  if (!release) {
    console.warn('Sentry initialization failed: release is not set.');
    return;
  }

  const environment = window.env.ENVIRONMENT;
  if (!environment) {
    console.warn('Sentry initialization failed: environment is not set.');
    return;
  }

  baseConfig = {
    release,
    dsn,
    environment,
    debug: true,
    integrations: [new CaptureConsoleIntegration({ levels: ['error'] })],
    normalizeDepth: 10,
    beforeBreadcrumb: (breadcrumb) => {
      if (breadcrumb.category === 'navigation') {
        if (typeof breadcrumb.data === 'object') {
          const from = replaceSensitiveDataFromPath(breadcrumb.data?.from);
          const to = replaceSensitiveDataFromPath(breadcrumb.data?.to);
          return { ...breadcrumb, data: { ...breadcrumb.data, from, to } };
        }
      }
      return breadcrumb;
    },
    beforeSend: async (event) => event,
  };
  Sentry.init(baseConfig);
};

export const addIntegration = (integrations: Integration[]): void => {
  if (!baseConfig) {
    return;
  }
  Sentry.getCurrentHub().bindClient(
    new Sentry.BrowserClient({ ...baseConfig, integrations: (old) => [...old, ...integrations] }),
  );
};
